<!--
 * @Author: your feedbackPersonName
 * @Date: 2020-02-14 11:20:46
 * @LastEditTime: 2021-01-22 17:20:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-supplier\pages\index\src\routes\member\login\feedback.vue
 -->
<template>
  <div class="feedback">
    <SyPopup
      :title='pageText.feedback'
      :modal-append-to-body="false"
      :lock-scroll="false"
      v-model='visible'
    >
      <p class="tips">
        {{pageText.fillInformation}}
        <i class="tips-icon"></i>
      </p>
      <SyForm :model="feedbackInfo" class="feedback-feedbackContent" label-width="80px" :rules="rules" ref="form" pageType='popup' style="font-size: 0" span="0">
        <SyFormItem :label="pageText.feedbackType" class="feedbackType"  prop="feedbackType" :isText="true">
          <el-radio-group v-model="feedbackInfo.feedbackType">
            <el-radio label="1">{{pageText.realName}}</el-radio>
            <el-radio label="0">{{pageText.anonymous}}</el-radio>
          </el-radio-group>
        </SyFormItem>
        <!-- <el-form-item label="姓名" class="feedbackPersonName" prop="feedbackPersonName" v-if="feedbackInfo.feedbackType === '1'">
          <el-input :placeholder="pageText.tips" v-model.trim="feedbackInfo.feedbackPersonName"></el-input>
        </el-form-item> -->
        <SyFormItem :label="pageText.phone" class="feedbackPersonMobile" prop="feedbackPersonMobile" v-if="feedbackInfo.feedbackType === '1'" :span="1">
          <el-input :placeholder="pageText.tips" v-model.trim="feedbackInfo.feedbackPersonMobile"></el-input>
        </SyFormItem>
        <SyFormItem :label="pageText.title"  prop="title" :span="1">
          <el-input :placeholder="pageText.tips" v-model.trim="feedbackInfo.title"></el-input>
        </SyFormItem>
        <SyFormItem :label="pageText.feedbackContent"  prop="feedbackContent">
          <el-input type="textarea" :placeholder="pageText.tips" v-model.trim="feedbackInfo.feedbackContent" maxlength="500" show-word-limit></el-input>
        </SyFormItem>
        <SyFormItem :label="pageText.accessorys">
          <import-file :fileList="feedbackInfo.accessorys" @uploadSuccess="uploadSuccess" @delFile="delFile"></import-file>
        </SyFormItem>
      </SyForm>
      <!--按钮-->
      <span slot='footer' class='dialog-footer'>
        <Buttons class="cancel" @click='cancel'>{{pageText.cancel}}</Buttons>
        <Buttons type='primary' @click='confirm'>{{pageText.confirm}}</Buttons>
      </span>
    </SyPopup>
  </div>
</template>

<script>
  import response from '../../../utils/response'
  import feedbackApi from './api.js'
  import ImportFile from './import-file'
  import { regexp } from '@/utils/index.js'
  import i18n from './i18n.js'
  import { componentMessage } from '../utils'
  import { SyForm, SyFormItem, Buttons, SyPopup } from './../../../index.js'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'feedback',
    components: {
      ImportFile,
      SyForm,
      SyFormItem,
      Buttons,
      SyPopup
    },
    data () {
      return {
        pageText,
        componentMessage,
        visible: false,
        feedbackInfo: {
          feedbackType: null,
          feedbackPersonName: '',
          feedbackPersonMobile: '',
          title: '',
          feedbackContent: '',
          accessorys: []
        },
        fileUploadStatus: false,
        maxFileSize: 50 * 1024 * 1024 - 1,
        uploadErrMsg: pageText.uploadErrMsg,
        upload: feedbackApi.upload.url, //附件上传的url
        rules: {
          feedbackType: [
            { required: true, message: pageText.feedbackTypeTips, trigger: ['blur', 'change'] }
          ],
          feedbackPersonName: [
            { min: 0, max: 10, message: this.variableReplace(pageText.inputTips, {n: 10}), trigger: ['blur', 'change'] }
          ],
          feedbackPersonMobile: [
            { validator: this.validateRules, trigger: 'blur' },
            { min: 0, max: 20, message: this.variableReplace(pageText.inputTips, {n: 20}), trigger: ['blur', 'change'] }
          ],
          title: [
            { required: true, message: pageText.titleTips, trigger: ['blur', 'change'] },
            { min: 0, max: 30, message: this.variableReplace(pageText.inputTips, {n: 30}), trigger: ['blur', 'change'] }
          ],
          feedbackContent: [
            { required: true, message: pageText.feedbackTips, trigger: ['blur', 'change'] }
          ]
        }
      }
    },
    methods: {
      variableReplace: window.fe.variableReplace,
      uploadSuccess (file) {
        this.feedbackInfo.accessorys.push(file)
      },
      delFile (index) {
        this.feedbackInfo.accessorys = this.feedbackInfo.accessorys.filter((ele, ind) => {
          return ind !== index
        })
      },
      validateRules (rule, value, callback) {
        value = (value + '').trim()
        if (value === '' || regexp.phone.test(value) || regexp.fixedTel.test(value)) {
          return callback()
        }
        callback(new Error(this.pageText.correctPhone))
      },
      open () {
        this.visible = true
        this.feedbackInfo.accessorys = []
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.resetFields()
        })
      },
      cancel () {
        this.visible = false
      },
      confirm () {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.saveFeedback()
          } else {
            this.$message.error(this.pageText.correctTips)
          }
        })
      },
      async saveFeedback () {
        let api = feedbackApi.save
        let params = Object.assign({}, this.feedbackInfo)
        if (this.feedbackInfo.feedbackType === '0') {
          params.feedbackPersonName = ''
          params.feedbackPersonMobile = ''
        }
        let res = await response(this.$http(api.type, api.url, params))
        if (res.isOk) {
          this.$message.success(this.pageText.submitSuccess)
          this.cancel()
        }
      }
    },
    created () {
      let flag = this.componentMessage(['mall', 'purchaser', 'supplier'], 'feedback-dialog 意见反馈弹框')
      if (flag) return
    }
  }
</script>

<style scoped lang="scss">
.tips{
  background: #ABB7CD;
  padding: 0 20px;
  height: 84px;
  line-height: 84px;
  font-size: 16px;
  color: #FFFFFF;
  margin-bottom: 20px;
  position: relative;
  .tips-icon{
    position: absolute;
    right: 20px;
    top: 16px;
    display: inline-block;
    width: 63px;
    height: 55px;
    background: url($img-url + '159479262415692706.svg');
  }
}
</style>
<style lang="scss">
.feedback{
  .feedback-feedbackContent{
    .el-form-item{
      margin-bottom: 16px;
      .el-form-item__label,
      .el-form-item__feedbackContent{
        font-size: 12px;
        color: #666666;
      }
      .el-radio__label{
        font-size: 12px;
        color: #333;
        font-weight: normal;
      }
      .el-textarea__inner{
        height: 128px;
      }
    }
  }
  div.el-dialog__body{
    padding: 0;
    .el-textarea .el-input__count{
      background-color: #FFFDEF;
      right: 20px;
      bottom: 2px;
    }
  }
  div.el-dialog__footer{
    padding: 12px;
    border-top: 1px solid rgba(197,197,197,0.50);
  }
}
</style>
